/* Perdah - sepete ekleme

   Urun formu (#pk-product-form) native POST /cart/add + return_to=/cart kullaniyordu:
   sepete eklenince tam sayfa yenilenip sepet sayfasina gidiliyordu. Burada form
   AJAX'a cevrilir ve Dawn'in <cart-drawer> ogesi renderContents() ile acilir.

   Sections API: 'cart-drawer' ve 'cart-icon-bubble' istenir - CartDrawer.getSectionsToRender()
   tam bu iki id'yi bekler. Drawer yoksa (cart_type: page/notification) veya istek
   basarisiz olursa native gonderime duser, yani JS kapaliyken de sepete ekleme calisir.

   ONEMLI - is-empty: sayfa sepet BOSKEN yuklendiginde Liquid, host <cart-drawer> ogesine
   ve <cart-drawer-items>'a 'is-empty' sinifini basar. renderContents() yalnizca
   .drawer__inner'in ic HTML'ini degistirir, host'un sinifina dokunmaz. Sinif kalirsa:
   basligi gizler (cart-drawer.is-empty .drawer__header{display:none}), paneli
   display:grid + padding:0 yapar ve footer'i yok eder
   (cart-drawer-items.is-empty + .drawer__footer{display:none}) - yani ilk kez sepete
   ekleyen HER ziyaretci bozuk cekmece gorur. Asagida elle temizleniyor.
*/
(function () {
  if (window.__pdSepetBagli) return;
  window.__pdSepetBagli = true;

  function bosSinifiTemizle(drawer) {
    drawer.classList.remove('is-empty');
    drawer.querySelectorAll('.is-empty').forEach(function (el) { el.classList.remove('is-empty'); });
  }

  function bagla() {
    var form = document.getElementById('pk-product-form');
    if (!form || form.dataset.pdBagli) return;
    form.dataset.pdBagli = '1';

    form.addEventListener('submit', function (e) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') return;
      e.preventDefault();

      var butonlar = [];
      var b1 = form.querySelector('.pk-buy');
      var b2 = document.querySelector('.pk-sbbuy');
      if (b1) butonlar.push(b1);
      if (b2) butonlar.push(b2);
      var eskiMetin = butonlar.map(function (b) { return b.textContent; });
      butonlar.forEach(function (b) { b.disabled = true; b.textContent = 'Ekleniyor...'; });

      function geriAl() {
        butonlar.forEach(function (b, i) { b.disabled = false; b.textContent = eskiMetin[i]; });
      }

      var fd = new FormData(form);
      fd.delete('return_to');
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message || 'sepete eklenemedi');
          geriAl();
          drawer.renderContents(res);
          bosSinifiTemizle(drawer);
          // renderContents open()'i setTimeout ile cagirir; o tur bittikten sonra
          // gelen HTML yeniden is-empty tasiyor olabilir, ikinci kez temizle.
          setTimeout(function () { bosSinifiTemizle(drawer); }, 0);
        })
        .catch(function () {
          /* Sunucu hatasi veya beklenmeyen yanit: kullaniciyi bosclukta birakma,
             native gonderimle sepet sayfasina goturur. */
          geriAl();
          form.dataset.pdBagli = '';
          form.submit();
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bagla);
  } else {
    bagla();
  }
})();
